import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyReceipt = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.20007 7.79993H12.0001"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.20007 11.3999H10.2001"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.20007 14.9999H10.2001"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6001 7.79993H16.8001"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5137 15.6512C13.6868 15.8789 13.9124 16.0615 14.1712 16.1834C14.4299 16.3052 14.7143 16.3628 15.0001 16.3512C15.9113 16.3512 16.6497 15.7968 16.6497 15.1136C16.6497 14.4304 15.9113 13.876 15.0001 13.876C14.0889 13.876 13.3497 13.3216 13.3497 12.6376C13.3497 11.9536 14.0889 11.4 15.0001 11.4C15.2859 11.3886 15.5703 11.4462 15.829 11.5681C16.0878 11.69 16.3133 11.8724 16.4865 12.1"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 16.3512V17.1752"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 10.576V11.4"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6 21C15.7836 20.6854 16.0464 20.4245 16.3622 20.2431C16.678 20.0617 17.0358 19.9663 17.4 19.9663C17.7642 19.9663 18.1221 20.0617 18.4379 20.2431C18.7537 20.4245 19.0165 20.6854 19.2 21V3C19.016 3.3142 18.7532 3.57492 18.4375 3.75634C18.1218 3.93776 17.7642 4.03361 17.4 4.0344C17.0359 4.03369 16.6783 3.93788 16.3626 3.75645C16.0468 3.57501 15.784 3.31426 15.6 3C15.416 3.3142 15.1532 3.57492 14.8375 3.75634C14.5218 3.93776 14.1642 4.03361 13.8 4.0344C13.4359 4.03369 13.0783 3.93788 12.7626 3.75645C12.4468 3.57501 12.184 3.31426 12 3C11.816 3.3142 11.5532 3.57492 11.2375 3.75634C10.9218 3.93776 10.5642 4.03361 10.2 4.0344C9.83591 4.03369 9.47828 3.93788 9.16256 3.75645C8.84685 3.57501 8.584 3.31426 8.40005 3C8.21604 3.3142 7.95318 3.57492 7.63747 3.75634C7.32177 3.93776 6.96417 4.03361 6.60005 4.0344C6.23591 4.03369 5.87828 3.93788 5.56256 3.75645C5.24685 3.57501 4.984 3.31426 4.80005 3V21C4.98359 20.6854 5.24637 20.4245 5.56219 20.2431C5.87801 20.0617 6.23585 19.9663 6.60005 19.9663C6.96425 19.9663 7.32209 20.0617 7.63791 20.2431C7.95373 20.4245 8.21651 20.6854 8.40005 21C8.58359 20.6854 8.84637 20.4245 9.16219 20.2431C9.47801 20.0617 9.83585 19.9663 10.2 19.9663C10.5642 19.9663 10.9221 20.0617 11.2379 20.2431C11.5537 20.4245 11.8165 20.6854 12 21"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 20.9999C12.1835 20.6854 12.4463 20.4244 12.7621 20.243C13.078 20.0616 13.4358 19.9662 13.8 19.9662C14.1642 19.9662 14.522 20.0616 14.8379 20.243C15.1537 20.4244 15.4165 20.6854 15.6 20.9999"
          stroke="currentColor"
          strokeWidth={1.125}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyReceipt.displayName = 'SvgMoneyReceipt';
export default SvgMoneyReceipt;
